import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { useConsent } from '@/contexts/ConsentContext';

const ConsentModal: React.FC = () => {
  const { consent, closeModal, savePreferences, rejectAll } = useConsent();
  const [analyticsEnabled, setAnalyticsEnabled] = useState(
    consent?.analytics ?? false
  );

  const handleRejectAll = () => {
    rejectAll();
  };

  const handleSave = () => {
    savePreferences(analyticsEnabled);
  };

  return (
    <Dialog open onOpenChange={(open) => { if (!open) closeModal(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Cookie preferences</DialogTitle>
          <DialogDescription>
            Choose which cookies you allow. Strictly necessary cookies cannot be
            disabled.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Strictly Necessary */}
          <div className="flex items-center justify-between gap-4 rounded-lg border border-border p-4">
            <div className="space-y-1 min-w-0">
              <Label className="text-sm font-medium">Strictly necessary</Label>
              <p className="text-xs text-muted-foreground">
                Required for the application to function. Covers authentication,
                session management, security, and UI preferences.
              </p>
            </div>
            <Switch
              checked
              disabled
              aria-label="Strictly necessary cookies (always on)"
            />
          </div>

          {/* Analytics */}
          <div className="flex items-center justify-between gap-4 rounded-lg border border-border p-4">
            <div className="space-y-1 min-w-0">
              <Label htmlFor="analytics-toggle" className="text-sm font-medium">
                Analytics
              </Label>
              <p className="text-xs text-muted-foreground">
                Error monitoring and product analytics via Sentry and Google
                Analytics. Helps us identify issues and improve the product.
              </p>
            </div>
            <Switch
              id="analytics-toggle"
              checked={analyticsEnabled}
              onCheckedChange={setAnalyticsEnabled}
              aria-label="Analytics cookies"
            />
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={handleRejectAll}>
            Reject all
          </Button>
          <Button onClick={handleSave}>Save preferences</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConsentModal;
